import { ChangeDetectionStrategy, Component, computed, EventEmitter, input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';

@Component({
  selector: 'tf-number-input',
  standalone: true,
  imports: [FormsModule, InputNumberModule],
  template: `
    <p-inputNumber
      [inputId]="inputId()"
      [placeholder]="placeholder()"
      [ngModel]="numberValue()"
      (ngModelChange)="onNumberChange($event)"
      [invalid]="invalid()"
      class="w-full"
    />
  `,
  styles: ':host { display: block; width: 100%; }',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumberInputComponent {
  readonly value = input<string>('');
  readonly placeholder = input<string>('');
  readonly inputId = input<string>('tf-number-input');
  readonly invalid = input<boolean>(false);
  @Output() readonly valueChange = new EventEmitter<string>();

  readonly numberValue = computed<number | null>(() => {
    const str = this.value();
    if (str === '') return null;
    const n = Number(str);
    return isNaN(n) ? null : n;
  });

  onNumberChange(val: number | null): void {
    this.valueChange.emit(val != null ? String(val) : '');
  }
}
